import { SerializedStyles, css } from "@emotion/react";
import { fade } from "@material-ui/core/styles";

import theme from "../../styles/theme";
import { white, black } from "../../styles/variables";

export const table = (minWidth?: string): SerializedStyles => css`
  min-width: ${minWidth};
  background: ${white};
`;

export const row = css`
  text-decoration: none;
  cursor: pointer;

  &:hover {
    background: ${fade(black, 0.035)};
  }
`;

export const cell = (width: string): SerializedStyles => css`
  width: ${width};
`;

export const content = css`
  display: flex;
  align-items: center;
`;

export const img = css`
  margin-right: ${theme.spacing(2)}px;
  width: 82px;
  min-width: 82px;
  height: 46px;
`;

export const dot = (color?: string): SerializedStyles => css`
  &::before {
    content: "";
    display: ${color ? "inline-block" : "none"};
    margin-right: ${theme.spacing(1)}px;
    width: 9px;
    height: 9px;
    border-radius: 50%;
    background: ${color};
  }
`;

export const txt = css`
  word-break: break-all;
`;
